import { useMemo } from 'react'
import type { ButtonProps } from './Button.types'
import * as S from './Button.styles'
import LoadingWrapper, { LoadingWrapperProps } from './LoadingWrapper'

const Button = ({
  size = 'medium',
  disableElevation = true,
  children,
  loading,
  loadingIconSize,
  disabled,
  startIcon,
  endIcon,
  ...props
}: ButtonProps) => {
  const isNotIcon = !startIcon && !endIcon

  const loadingWrapperProps = useMemo<LoadingWrapperProps>(() => {
    return { children, size, loadingIconSize }
  }, [children, size, loadingIconSize])

  return (
    <S.Button
      size={size}
      startIcon={loading ? undefined : startIcon}
      endIcon={loading && !startIcon ? undefined : endIcon}
      disabled={loading ? true : disabled}
      disableElevation={disableElevation}
      {...props}
    >
      {loading && startIcon && (
        <LoadingWrapper
          {...loadingWrapperProps}
          innerStyle={{ marginRight: '6.5px', marginLeft: '-4px' }}
        >
          {startIcon}
        </LoadingWrapper>
      )}

      {!(loading && isNotIcon) && children}
      {loading && isNotIcon && <LoadingWrapper {...loadingWrapperProps}>{children}</LoadingWrapper>}

      {loading && endIcon && !startIcon && (
        <LoadingWrapper
          {...loadingWrapperProps}
          innerStyle={{ marginRight: '-4px', marginLeft: '6.5px' }}
        >
          {endIcon}
        </LoadingWrapper>
      )}
    </S.Button>
  )
}

export default Button
